import React from 'react';
import { localize } from 'react-localize-redux';
import camelCase from 'lodash/camelCase';
import styled from 'styled-components';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import { colors, applicationColors, maintenanceColors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledTag = styled.div`
  width: fit-content;
  height: 20px;
  padding: 0 4px;
  text-align: center;
  margin-top: ${(props) => props.topMargin || '0px'};
  margin-left: ${(props) => props.leftMargin || '0px'};
  background-color: ${(props) => props.color || colors.SLATE_GREY};
  border-radius: 4px;
  color: #fff;
  display: ${(props) => props.display || 'flex'};
  align-items: center;
`;

const StyledSpan = styled.span`
  font-size: 12px;
  text-transform: lowercase;
  line-height: 8px;
  white-space: nowrap;
`;

class StatusTag extends React.Component {
  colorMap = {
    // TODO: Need to update when we have full color scheme for statuses
    active: '#0ca068',
    confirmed: '#0ca068',
    'future tenant': colors.PUMPKIN_ORANGE,
    'not invited': colors.SLATE_GREY,
    opted_out: colors.PUMPKIN_ORANGE,
    inactive: '#65666d',
    deactivated: '#65666d',
    invited: colors.ULTRAMARINE_BLUE,
    inviting: colors.YELLOW_ORANGE,
    'no email': colors.YUHU_RED_TINT,
    new: colors.YUHU_RED,
    reviewed: colors.LIGHT_PURPLE,
    deferred: colors.YELLOW_ORANGE,
    auto_deferred: colors.YELLOW_ORANGE,
    acknowledged: '#e27d00',
    scheduled: '#e27d00',
    proposed_scheduled_date: '#e27d00',
    assigned: '#e27d00',
    open: '#e27d00',
    'contact tenant': colors.YUHU_RED,
    'contractor needed': maintenanceColors.CONTRACTOR_NEEDED,
    'contractor needed review': maintenanceColors.CONTRACTOR_NEEDED,
    contractor_requested: '#6d58ff',
    vendor_other: '#6d58ff',
    vendor_ongoing: '#6d58ff',
    job_complete: '#33a387',
    fixed: '#33a387',
    fixing: '#e27d00',
    need_parts: '#6d58ff',
    'parts needed': maintenanceColors.PARTS_NEEDED,
    'parts needed review': maintenanceColors.PARTS_NEEDED,
    vendor_cancelled: colors.DARK,
    cancelled_dup: colors.DARK,
    cancelled_no_res: colors.DARK,
    cancelled: colors.DARK,
    closed: colors.SLATE_GREY,
    moved_out: '#f7b500',
    delivered: '#33c733',
    'partially delivered': '#bec733',
    'queued for delivery': colors.YELLOW_ORANGE,
    expired: colors.SLATE_GREY,
    'in contact': colors.PUMPKIN_ORANGE,
    applying: colors.LIGHT_PURPLE,
    rejected: colors.YUHU_RED,
    converted: '#33c733',
    'booked showing': colors.DARK,
    stale: colors.YUHU_RED,
    waitlisted: colors.SLATE_GREY,
    upcoming: colors.LIGHT_PURPLE,
    assign: colors.DARK,
    complete: '#33c733',
    no_show: colors.YUHU_RED,
    payment_received: applicationColors.PAYMENT_RECEIVED,
    application_denied: applicationColors.APPLICATION_DENIED,
    pending_tenant_signature: applicationColors.PENDING_TENANT_SIGNATURE,
    pending_lease_approval: applicationColors.PENDING_LEASE_APPROVAL,
    create_lease: applicationColors.CREATE_LEASE,
    pending_landlord_signature: applicationColors.PENDING_LANDLORD_SIGNATURE,
    pending_application_submission: applicationColors.PENDING_APPLICATION_SUBMISSION,
    pending_all_tenants: applicationColors.PENDING_ALL_TENANTS,
    flagged: applicationColors.FLAGGED,
    pending: applicationColors.PENDING,
    approved: applicationColors.APPROVED,
    pending_approval: applicationColors.PENDING_APPROVAL,
    pending_payment: applicationColors.PENDING_PAYMENT,
    leased_to_other_applicant: applicationColors.LEASED_TO_OTHER_APPLICANT,
    unit_reserved_for_other: applicationColors.UNIT_RESERVED_FOR_OTHER,
    waived: '#0091ff',
    paid: colors.GREEN,
    late: colors.YUHU_RED,
    nsf: colors.YUHU_RED,
    autopay: colors.ULTRAMARINE_BLUE,
    in_review: colors.YELLOW_ORANGE,
    needs_review: colors.LIGHT_PURPLE,
    denied: colors.YUHU_RED,
    ontrack: colors.CHECKMARK_GREEN,
    overdue: colors.PUMPKIN_ORANGE,
    processed: colors.CHECKMARK_GREEN,
    processing: colors.ULTRAMARINE_BLUE,
    current: colors.CHECKMARK_GREEN,
    future: colors.PUMPKIN_ORANGE,
    prior: colors.STATE_BLUE,
    processed_outcome_successful: colors.CHECKMARK_GREEN,
    processed_outcome_generic_failure: colors.YUHU_RED,
    processed_outcome_nsf: colors.YUHU_RED_TINT,
    processed_outcome_voided: colors.YUHU_RED_TINT,
    lease_holder: colors.CHECKMARK_GREEN,
    pending_application: colors.PUMPKIN_ORANGE,
    application_completed: colors.CHALK_BLUE,
    processed_outcome_deleted_pap_details: colors.YUHU_RED_TINT,
  };

  render() {
    const { status, topMargin, leftMargin, display } = this.props;

    if (!status) return null;
    const color = this.colorMap[`${status.toLowerCase()}`];

    return (
      <StyledTag color={color} topMargin={topMargin} leftMargin={leftMargin} display={display}>
        <StyledSpan>
          {status.toLowerCase() === 'contact tenant' ? (
            <span>
              {getTranslatedString('landlordPortal.statusTag.apiStatus.contact')}{' '}
              <TenantResidentVerbiageHelper />
            </span>
          ) : (
            `${getTranslatedString(`landlordPortal.statusTag.apiStatus.${camelCase(status)}`)}`
          )}
        </StyledSpan>
      </StyledTag>
    );
  }
}

export default localize()(StatusTag);
